import { cn } from "@/shared/lib/utils";

const PREFERENCE_LEVELS: Array<{ label: string; value: number }> = [
  { label: "---", value: -0.15 },
  { label: "--", value: -0.1 },
  { label: "0", value: 0 },
  { label: "++", value: 0.1 },
  { label: "+++", value: 0.15 },
];

type Props = {
  value: number;
  onChange: (v: number) => void;
  disabled?: boolean;
};

export function PreferenceSlider({ value, onChange, disabled }: Props) {
  return (
    <div className="inline-flex gap-1">
      {PREFERENCE_LEVELS.map((lvl) => {
        const selected = Math.abs(value - lvl.value) < 1e-6;
        return (
          <button
            key={lvl.label}
            type="button"
            disabled={disabled}
            data-selected={selected}
            aria-pressed={selected}
            onClick={() => onChange(lvl.value)}
            className={cn(
              "px-2 py-1 text-xs rounded border min-w-[36px] transition",
              selected
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-background text-muted-foreground hover:bg-muted",
              disabled && "opacity-50 cursor-not-allowed"
            )}
          >
            {lvl.label}
          </button>
        );
      })}
    </div>
  );
}
